/// <amd-module name="Release/Helpers/ReleaseContractsStatusConverter" />
import { EnvironmentStatus, DeploymentStatus, DeploymentOperationStatus } from "Release/Client/Contracts/Release";

export class ReleaseContractsStatusConverter {
    public static toEnvironmentStatus(environmentStatus: string): EnvironmentStatus{
        switch (environmentStatus.toLowerCase()) {
            case "succeeded":
                return EnvironmentStatus.Succeeded;
            case "inprogress":
                return EnvironmentStatus.InProgress;
            case "rejected":
                return EnvironmentStatus.Rejected;
            case "canceled":
                return EnvironmentStatus.Canceled;
            case "partiallysucceeded":
                return EnvironmentStatus.PartiallySucceeded;
            case "queued":
                return EnvironmentStatus.Queued;
            default:
                return EnvironmentStatus.Undefined;
        }
    }

    public static toDeploymentStatus(deploymentStatus: string): DeploymentStatus {
        switch (deploymentStatus.toLowerCase()) {
            case "all":
                return DeploymentStatus.All;
            case "notdeployed":
                return DeploymentStatus.NotDeployed;
            case "inprogress":
                return DeploymentStatus.InProgress;
            case "succeeded":
                return DeploymentStatus.Succeeded;
            case "partiallysucceeded":
                return DeploymentStatus.PartiallySucceeded;
            case "failed":
                return DeploymentStatus.Failed;
            default:
                return DeploymentStatus.Undefined;
        }
    }

    public static toDeploymentOperationStatus(deploymentOperationStatus: string): DeploymentOperationStatus {
        switch (deploymentOperationStatus.toLowerCase()) {
            case "queued":
                return DeploymentOperationStatus.Queued;
            case "scheduled":
                return DeploymentOperationStatus.Scheduled;
            case "pending":
                return DeploymentOperationStatus.Pending;
            case "approved":
                return DeploymentOperationStatus.Approved;
            case "rejected":
                return DeploymentOperationStatus.Rejected;
            case "deferred":
                return DeploymentOperationStatus.Deferred;
            case "queuedforagent":
                return DeploymentOperationStatus.QueuedForAgent;
            case "phaseinprogress":
                return DeploymentOperationStatus.PhaseInProgress;
            case "phasesucceeded":
                return DeploymentOperationStatus.PhaseSucceeded;
            case "phasepartiallysucceeded":
                return DeploymentOperationStatus.PhasePartiallySucceeded;
            case "phasefailed":
                return DeploymentOperationStatus.PhaseFailed;
            case "canceled":
                return DeploymentOperationStatus.Canceled;
            case "phasecanceled":
                return DeploymentOperationStatus.PhaseCanceled;
            case "manualinterventionpending":
                return DeploymentOperationStatus.ManualInterventionPending;
            case "queuedforpipeline":
                return DeploymentOperationStatus.QueuedForPipeline;
            case "cancelling":
                return DeploymentOperationStatus.Cancelling;
            case "evaluatinggates":
                return DeploymentOperationStatus.EvaluatingGates;
            case "gatefailed":
                return DeploymentOperationStatus.GateFailed;
            default:
                return DeploymentOperationStatus.Undefined;
        }
    }
}
